<template>
  <div class="menu-container">
    <div v-if="windowWidth > 768">
      <v-list dense>
        <v-navigation-drawer
          class="menu-container__app-drawer"
          v-model="drawer"
          app
          floating
          persistent
          mobile-break-point="991"
          width="200"
          :clipped="clipped"
          enable-resize-watcher
        >
          <v-img height="100%">
            <v-layout class="fill-height" tag="v-list" column>
              <div class="menu-container__app-drawer__logo-container">
                <img :src="logo" @click="backToHome" />
              </div>
              <div class="menu-container__items-container">
                <div>
                  <v-list-item
                    v-for="(link, i) in links"
                    :key="i"
                    :to="link.to"
                    class="v-list-item"
                  >
                    <div
                      @click="moveRoute(link.to); clearRouter(link.to)"
                      class="menu-container__link-route"
                    >
                      <v-list-item-action>
                        <v-icon>{{ link.icon }}</v-icon>
                      </v-list-item-action>
                      <v-list-item-title v-text="link.text" />
                    </div>
                  </v-list-item>
                </div>
                <div class="menu-container-company__link-roles">
                  <v-list-item
                    v-for="(link, i) in linksRoles"
                    :key="i+5"
                    :to="link.to"
                    class="v-list-item"
                  >
                    <div
                      @click="moveRoute(link.to); clearRouter(link.to)"
                      class="menu-container__link-route"
                    >
                      <v-list-item-action>
                        <v-icon>{{ link.icon }}</v-icon>
                      </v-list-item-action>
                      <v-list-item-title v-text="link.text" />
                    </div>
                  </v-list-item>
                </div>
              </div>
            </v-layout>
          </v-img>
        </v-navigation-drawer>
        <v-app-bar fixed app :clipped-left="clipped">
          <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
          <div class="menu-container__header-container">
            <span class="menu-container__company-code">企業コード：{{companyCode}}</span>
            <v-toolbar-title>{{title}}</v-toolbar-title>
          </div>
        </v-app-bar>
      </v-list>
    </div>
    <div v-else>
      <div class="menu-container__expand">
        <div class="menu-container__expand__dropdown-logo">
          <img height="32px" :src="logo" @click="backToHome" />
        </div>
        <v-icon v-text="'$vuetify.icons.menu'" @click.stop="controlMenu"></v-icon>
      </div>
      <v-expansion-panels v-model="menuValue">
        <v-expansion-panel>
          <v-expansion-panel-content v-for="(item,i) in 1" :key="i">
            <v-list-item
              v-for="(link, i) in links"
              :key="i"
              :to="link.to"
              class="v-list-item"
              @click="controlMenu"
            >
              <v-list-item-action>
                <v-icon>{{ link.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-title v-text="link.text" />
            </v-list-item>
            <v-list-item
              v-for="(link, i) in linksRoles"
              :key="i+5"
              :to="link.to"
              class="v-list-item"
              @click="controlMenu"
            >
              <v-list-item-action>
                <v-icon>{{ link.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-title v-text="link.text" />
            </v-list-item>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="menu-container__header-container">
        <span class="menu-container__company-code">企業コード：{{companyCode}}</span>
        <p class="menu-container__expand__header font--bold -lg">{{title}}</p>
      </div>
    </div>
  </div>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState
} from 'vuex'
import utils from '@/utils'
import {
  createComponent,
  inject,
  onMounted,
  computed,
  watch
} from "@vue/composition-api";
import CompanyRecruitmentKey from "@/components/company-recruitment-key";
import CompanyKey from "@/components/company-key";
import CompanyCheckAmountKey from "@/components/company-check-amout-key";
import DisplayUIKey from "@/components/display-ui-key";
import router from '../../../router'
export default createComponent( {
  props: ["windowWidth","companyCode"],
  
  setup(props, context){
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const companyRecruitment = inject(CompanyRecruitmentKey);
    if (!companyRecruitment) {
      throw new Error(`${CompanyRecruitmentKey} is not provided`);
    }
      const companyCheckAmount = inject(CompanyCheckAmountKey);
    if (!companyCheckAmount) {
      throw new Error(`${CompanyCheckAmountKey} is not provided`);
    }
    watch(() =>context.root.$route , (first, second) => {
      displayui.closeDeleteJobDialog()
      displayui.closeDeleteJobDialogDraf()
      companyRecruitment.resetNoResultText()
    });

    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
  

    const clearRouter = (link) => {
      if(link =='/company_offer' || link =='/company_offer/draft' ) {
        companyRecruitment.clearSearchParams()
      }
      if(link =='/company_payment') {
        companyCheckAmount.resetTableValue()
        companyCheckAmount.getSettlementInfor(new Date().toISOString().substr(0, 7))
        companyCheckAmount.setMonthValue(new Date().toISOString().substr(0, 7))
      }
      if(link =='/') {
        company.clearBtnCardText()
      }
    }
    watch(() =>context.root.$route , (first, second) => {
      if(context.root.$route.fullPath == '/company_offer/draft'){
        displayui.closeDeleteJobDialog()
        router.push('/company_offer/draft', ()=>{})
      }
      if(context.root.$route.fullPath == '/company_offer'){
        displayui.closeDeleteJobDialog()
        router.push('/company_offer', () => {})
      }
    });
    return {
      clearRouter
    }
  },
  data: () => ({
    logo: require('@/assets/img/logo-jobpay.png'),
    menuValue: 1,
    drawer: true,
    clipped: false,
    title: '',
    links: [
      {
        to: '/company_detail',
        icon: 'mdi-office-building',
        text: '企業'
      },
      {
        to: '/company_offer',
        icon: 'mdi-clipboard-outline',
        text: '求人'
      },
      {
        to: '/company_payment',
        icon: 'mdi-check-underline',
        text: '金額確認'
      },
      {
        to: '/',
        icon: 'mdi-logout',
        text: 'ログアウト'
      },
    ],
    linksRoles: [
      {
        to: '/company_specified_commercial_transaction',
        text: '特定商取引法に基づく表記'
      },
      {
        to: '/company_privacy_policy',
        text: 'プライバシーポリシー'
      },
       {
        to: '/company_antisocial',
        text: '反社会的勢力に対する基本方針'
      },
      {
        to: '/company_policy',
        text: 'ご利用規約'
      },
       {
        to: '/company_publication_rules',
        text: '掲載規定'
      },
    ],
  }),
 created () {
    this.title = utils.getTitle(window.location.pathname)
  },
  watch: {
    $route (to, from) {
      this.title = utils.getTitle(to.path)
    }
  },
   methods: {

    controlMenu() {
      if(this.menuValue == 1){
        this.menuValue= 0
      } else {
        this.menuValue= 1
      }
    }, 

    backToHome() {
      this.$router.push('/company_detail', () => {})
    },

    moveRoute(link) {
      if(link !== '/'){
        this.$router.push(`${link}`, () => {})
      } else if(link === '/'){
        window.localStorage.clear()
        this.$router.push(`${link}`, () => {})
      }
    }
}
})
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
@import "@/assets/scss/layout/company/menu.scss";
</style>